module.exports = __webpack_public_path__ + "img/Boot.18055e1a.jpg";